import { PlusIcon } from "@heroicons/react/24/outline";
import { Button } from "V2.0/common/button";
import PayloadMappingTable from "./PayloadMappingTable";
import usePayloadMapping from "./usePayloadMapping";
import PayloadMappingFormDialog from "./PayloadMappingFormDialog";
import AgentAutofill from "./AgentAutofill";

export default PayloadMapping;

function PayloadMapping(props) {
  const { payloadMapping, onUpdatePayloadMapping, assistants, workspaceId } =
    props;
  const {
    payloadMappings,
    payloadMappingDialog,
    addPayloadMapping,
    removePayloadMapping,
    updatePayloadMapping,
    replacePayloadMappings,
    openEditPayloadMappingDialog,
    openAddPayloadMappingDialog,
    closePayloadMappingDialog,
  } = usePayloadMapping(payloadMapping, onUpdatePayloadMapping);

  return (
    <>
      <div className="flex flex-col gap-y-4">
        <AgentAutofill
          assistants={assistants}
          workspaceId={workspaceId}
          onAutofill={replacePayloadMappings}
        />
        <div className="flex justify-between ">
          <p className="text-sm">Mapped Fields</p>
          <Button
            color="white"
            onClick={openAddPayloadMappingDialog}
          >
            <PlusIcon /> Field
          </Button>
        </div>
        <div>
          <PayloadMappingTable
            payloadMappings={payloadMappings}
            onMappingEdit={openEditPayloadMappingDialog}
            onMappingDelete={removePayloadMapping}
          />
        </div>
      </div>
      {!!payloadMappingDialog.mode && (
        <PayloadMappingFormDialog
          payloadMappingDialog={payloadMappingDialog}
          addPayloadMapping={addPayloadMapping}
          updatePayloadMapping={updatePayloadMapping}
          onClose={closePayloadMappingDialog}
        />
      )}
    </>
  );
}
